import { XProgress } from '@/components';

/**
 * @typedef {import('vue-router').Router} VueRouter
 */

/**
 * @typedef {import('./app-router').AppRouter} AppRouter
 */

/**
 * 注册路由进度条
 * @param {AppRouter} app
 */
export const progressGuard = (app) => {
    const router = app.router;
    router.beforeEach((to, from, next) => {
        XProgress.start();
        next();
    });

    router.afterEach(() => {
        XProgress.done();
    });
};
